import React from 'react';
import PropTypes from 'prop-types';

import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import ViewListProgram from '../ViewListProgram';

function ProgramDialog({ isVisible, setIsVisible, onSelectedChange, currentData, refetch }) {
  const { t } = useTranslation();

  return (
    <Dialog
      header={t('projectProposal.changeProgram.title')}
      visible={isVisible}
      onHide={() => {
        setIsVisible(false);
        onSelectedChange(null);
      }}
      draggable={false}
      className="w-full sm:w-9 lg:w-10"
    >
      <ViewListProgram
        onSelectedChange={onSelectedChange}
        setVisible={setIsVisible}
        currentData={currentData}
        refetch={refetch}
      />
    </Dialog>
  );
}

ProgramDialog.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  setIsVisible: PropTypes.func.isRequired,
  onSelectedChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  currentData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  refetch: PropTypes.func,
};

ProgramDialog.defaultProps = {
  currentData: null,
};

export default ProgramDialog;
